import { useEffect, useMemo, useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { unassignUser } from "../../../../redux/SettingModule/OrganizationDetailPage/OrganizationDetailAction";

interface DeleteUserConfirmModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
  tenantId: number | undefined;
}

function DeleteUserConfirmModal(props: DeleteUserConfirmModalProps) {
  const [form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const dispatch = useAppDispatch();
  const loading = useSelector((state: RootState) => state.OrganizationDetailPageState.unassignUserLoading);
  const currentRecord = useSelector((state: RootState) => state.UsersPageState.currentRecord);

  const [inputValue, setInputValue] = useState("");

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  useEffect(() => {
    return () => {
      setError("");
      form.resetFields();
      setInputValue("");
    };
  }, [props.openState]);

  const DeleteUserConfirmModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      try {
        await dispatch(
          unassignUser({
            idTenant: props.tenantId,
            userIds: [currentRecord.idUser],
          })
        ).unwrap();
        props.close();
        form.resetFields();
      } catch (error) {
        setError("An error occurred while deleting the user.");
      }
    };
    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4>Delete User</h4>
        <p>
          Please enter <strong>"permanently delete"</strong> to confirm the deletion of user:<strong></strong>
        </p>
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical">
          <Form.Item
            name="confirmation"
            rules={[{ required: true, message: "Please type 'permanently delete' to proceed." }]}>
            <Input
              placeholder="permanently delete"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button
              onClick={handleModalClose}
              loading={loading}>
              Cancel
            </Button>
            <Button
              type="primary"
              danger
              htmlType="submit"
              loading={loading}
              disabled={inputValue !== "permanently delete"}>
              Delete
            </Button>
          </div>
        </Form>
      </div>
    );
  }, [inputValue, loading, error, loading]);

  return (
    <div>
      <Modal
        zIndex={1500}
        footer={[]}
        width={500}
        onCancel={handleModalClose}
        open={props.openState}>
        {DeleteUserConfirmModalContent}
      </Modal>
    </div>
  );
}

export default DeleteUserConfirmModal;
